import {Component, OnInit, Input, forwardRef, HostBinding} from '@angular/core'
import {Observable} from 'rxjs'
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms'

@Component({
  selector: 'app-ordered-multi-select',
  templateUrl: './ordered-multi-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OrderedMultiSelectComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class OrderedMultiSelectComponent
  implements OnInit, ControlValueAccessor
{
  selected = []
  @Input() items$: Observable<any>
  @Input() tooltip: string | null = null
  @Input() placeholder: string | null = null
  @Input() searchable = true
  @Input() bindLabel = 'name'
  @Input() disabled = false
  @Input() isInvalid = false
  @Input() required = false
  @Input() addItem = false

  @HostBinding('class.invalid') get getHoverState() {
    return this.isInvalid
  }

  constructor() {}

  private propagateChange = (_: any) => {}

  set value(val) {
    this.selected = val
    this.onChange(val)
  }

  ngOnInit() {}

  onChange(event) {
    this.propagateChange(this.selected)
  }

  writeValue(obj: any): void {
    if (obj) {
      this.selected = obj
    } else {
      this.selected = []
    }
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn
  }
  registerOnTouched(fn: any): void {
    // throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
  }
}
